import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import AIPerfumer from "@/pages/AIPerfumer";
import AIProfilePage from "@/pages/AIProfilePage";
import History from "@/pages/History";
import Subscription from "@/pages/Subscription";
import PerfumeryTech from "@/pages/PerfumeryTech";
import Journey from "@/pages/Journey";
import Academy from "@/pages/Academy";
import CourseDetail from "@/pages/CourseDetail";
import Lesson from "@/pages/Lesson";
import MyAccount from "@/pages/MyAccount";
import TWFH from "@/pages/TWFH";
import PerfumeryTechApp from "@/pages/PerfumeryTechApp";
import MyResearch from "@/pages/MyResearch";
import ResearchDetail from "@/pages/ResearchDetail";
import PTCWallet from "@/pages/PTCWallet";
import ProtectedRoute from "@/components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/journey" element={<Journey />} />
      <Route path="/twfh" element={<TWFH />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/ai-perfumer" element={<ProtectedRoute><AIPerfumer /></ProtectedRoute>} />
      <Route path="/ai-perfumer/:conversationId" element={<ProtectedRoute><AIPerfumer /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><AIProfilePage /></ProtectedRoute>} />
      <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
      <Route path="/subscription" element={<ProtectedRoute><Subscription /></ProtectedRoute>} />
      <Route path="/perfumery-tech" element={<ProtectedRoute><PerfumeryTech /></ProtectedRoute>} />
      <Route path="/academy" element={<ProtectedRoute><Academy /></ProtectedRoute>} />
      <Route path="/academy/:courseId" element={<ProtectedRoute><CourseDetail /></ProtectedRoute>} />
      <Route path="/academy/:courseId/lesson/:lessonId" element={<ProtectedRoute><Lesson /></ProtectedRoute>} />
      <Route path="/account" element={<ProtectedRoute><MyAccount /></ProtectedRoute>} />
      <Route path="/perfumery-tech-app" element={<ProtectedRoute><PerfumeryTechApp /></ProtectedRoute>} />
      <Route path="/research" element={<ProtectedRoute><MyResearch /></ProtectedRoute>} />
      <Route path="/research/:researchId" element={<ProtectedRoute><ResearchDetail /></ProtectedRoute>} />
      <Route path="/ptc-wallet" element={<ProtectedRoute><PTCWallet /></ProtectedRoute>} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster theme="dark" position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
